/* Hawkesbury Radio - site behaviour (no dependencies). Shared by the static site and the Shopify theme.
 *
 * Settings: the Shopify theme writes its section settings as JSON (#hr-player-data, #hr-schedule-data) and
 * a few asset URLs into window.HR; the static site uses the defaults below and window.hrSchedule (schedule.js).
 *
 * Player: hls.js (Media Source) wherever the browser supports it. Native HLS is only used on Safari / iPhone,
 * because newer Chrome reports native HLS support but fails on this station's audio segments
 * (DEMUXER_ERROR_COULD_NOT_PARSE). Glitches are retried; nothing ever opens another tab.
 * While the stream is playing, links inside the site load the next page in place so the audio never stops.
 */
(function () {
  "use strict";

  /* ------------------------------------------------------------------ settings */
  function readJSON(id) { var el = document.getElementById(id); if (!el) { return null; } try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function merge(a, b) { var o = {}, k; for (k in a) { if (Object.prototype.hasOwnProperty.call(a, k)) { o[k] = a[k]; } } for (k in b) { if (Object.prototype.hasOwnProperty.call(b, k) && b[k] !== null && b[k] !== undefined) { o[k] = b[k]; } } return o; }
  var HR = {}, STREAM_URL, STATION, BADGE, TAGLINE, NOW_ID, HISTORY, GUIDE_URL, THUMB, DEFAULT_ART, HLS_SRC, META_URL, HISTORY_URL;
  function opt(key, fallback) { return HR[key] !== undefined && HR[key] !== null && HR[key] !== "" ? HR[key] : fallback; }
  function readSettings() {                          // again after the theme editor re-renders the player or schedule section
    var sd = readJSON("hr-schedule-data") || {};
    HR = merge(merge(window.HR || {}, { guideUrl: sd.guideUrl, thumb: sd.thumb }), readJSON("hr-player-data") || {});
    STREAM_URL = String(opt("streamUrl", "https://streaming.starterfm.com/hls/hawkesburyradio/live.m3u8")).trim();
    STATION = String(opt("stationName", "Hawkesbury Radio"));
    BADGE = String(HR.badge === "" ? "" : opt("badge", "Online"));
    TAGLINE = String(opt("tagline", "The home of real local voices"));
    NOW_ID = String(HR.nowPlayingId === "" ? "" : opt("nowPlayingId", "9680")).replace(/\D/g, "");   // blank turns song titles off
    HISTORY = Math.max(1, Math.min(12, parseInt(opt("historyCount", 6), 10) || 6));
    GUIDE_URL = opt("guideUrl", "programme-guide.html");
    THUMB = opt("thumb", "img/shows/generic-show.jpg");
    DEFAULT_ART = opt("defaultArt", "img/brand/default-art.jpg");
    HLS_SRC = opt("hls", "script/hls.min.js");
    META_URL = NOW_ID ? "https://au.api.iheart.com/api/v3/live-meta/stream/" + NOW_ID + "/currentTrackMeta" : "";
    HISTORY_URL = NOW_ID ? "https://au.api.iheart.com/api/v3/live-meta/stream/" + NOW_ID + "/trackHistory?limit=13" : "";   // enough for the longest row (12)
  }
  readSettings();
  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var ORDER = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  var ABBR = { Monday: "Mon", Tuesday: "Tue", Wednesday: "Wed", Thursday: "Thu", Friday: "Fri", Saturday: "Sat", Sunday: "Sun" };
  var CLOCK_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  function byId(id) { return document.getElementById(id); }

  /* ------------------------------------------------------------------ schedule helpers */
  function parseTime(s) {
    var m = /^\s*(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)\s*$/i.exec(s || "");
    if (!m) { return null; }
    var h = parseInt(m[1], 10) % 12, mi = parseInt(m[2] || "0", 10);
    if (m[3].toLowerCase() === "pm") { h += 12; }
    return h + mi / 60;
  }
  function fmt(h) {                                  // 9am, 12:30pm
    h = ((h % 24) + 24) % 24;
    var hh = Math.floor(h) % 12 || 12, mi = Math.round((h % 1) * 60), ap = h < 12 ? "am" : "pm";
    return hh + (mi ? ":" + (mi < 10 ? "0" : "") + mi : "") + ap;
  }
  function fmtHour(h) {                              // 9:00am (programme guide style)
    h = ((h % 24) + 24) % 24;
    var hh = Math.floor(h) % 12 || 12, mi = Math.round((h % 1) * 60), ap = h < 12 ? "am" : "pm";
    return hh + ":" + (mi < 10 ? "0" : "") + mi + ap;
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function splitTitle(title) {                       // "Monday Morning with Leon" -> {name, with}
    var m = /^(.*?)\s+with\s+(.+)$/i.exec(title);
    return m ? { name: m[1], with: m[2] } : { name: title, with: "" };
  }

  var schedule = {}, CATS = {}, CATS_LC = {}, GUIDE_TITLE = "Hawkesbury Radio Online programme guide";
  function loadSchedule() {                          // -> {Day: [["9am-12pm", "Title", "Category", "/link"], ...]}
    var data = readJSON("hr-schedule-data");
    if (data && data.shows) {
      var days = {};
      data.shows.forEach(function (s) {
        if (!s || !s.day || !s.title || parseTime(s.start) === null || parseTime(s.end) === null) { return; }
        (days[s.day] = days[s.day] || []).push([String(s.start).trim() + "-" + String(s.end).trim(), s.title, s.category || "", s.link || ""]);
      });
      Object.keys(days).forEach(function (d) { days[d].sort(function (a, b) { return parseTime(a[0].split("-")[0]) - parseTime(b[0].split("-")[0]); }); });
      schedule = days; CATS = data.categories || {};
      if (data.title) { GUIDE_TITLE = data.title; }
    } else {
      schedule = window.hrSchedule || {}; CATS = window.hrCategories || {};
    }
    CATS_LC = {};
    Object.keys(CATS).forEach(function (c) { CATS_LC[c.trim().toLowerCase()] = CATS[c]; });
  }
  function showsFor(day) {
    return (schedule[day] || []).map(function (s) {
      var p = s[0].split("-"), st = parseTime(p[0]), en = parseTime(p[1]);
      if (en !== null && st !== null && en <= st) { en += 24; }
      return { start: st, end: en, title: s[1], cat: s[2] || "", link: s[3] || "", time: s[0].replace("-", " - ") };
    });
  }
  function nowOnAir() {
    var now = new Date(), h = now.getHours() + now.getMinutes() / 60, d = now.getDay();
    var today = showsFor(DAYS[d]), yesterday = showsFor(DAYS[(d + 6) % 7]);
    var current = null, next = null;
    yesterday.forEach(function (s) { if (s.end > 24 && h < s.end - 24) { current = s; } });
    today.forEach(function (s) {
      if (s.start <= h && h < s.end) { current = s; }
      if (s.start > h && (!next || s.start < next.start)) { next = s; }
    });
    return { current: current, next: next, today: today, day: d, dayName: DAYS[d], hour: h };
  }
  function catColour(c) { return CATS[c] || CATS_LC[String(c).trim().toLowerCase()] || "#EEEEEE"; }
  loadSchedule();

  /* ------------------------------------------------------------------ clock */
  function tick() {
    var n = new Date(), d = byId("ClockDate"), t = byId("ClockTime");
    if (d) { d.textContent = n.toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long" }); }
    if (t) { t.textContent = n.toLocaleTimeString("en-AU", { hour: "2-digit", minute: "2-digit" }); }
  }
  tick(); setInterval(tick, 15000);

  /* ------------------------------------------------------------------ on-air line (and player notices) */
  var notice = "";
  function onAirText() {
    var s = nowOnAir();
    if (s.current) { return s.current.title + " · until " + fmt(s.current.end); }
    if (s.next) { return "Music on " + (STATION + " " + BADGE).trim() + " · next: " + s.next.title + " at " + fmt(s.next.start); }
    return TAGLINE;
  }
  function renderOnAir() {
    var el = byId("OnAirShow"), n = byId("PlayerNotice");
    if (!el) { return; }
    if (n) { n.textContent = notice; n.hidden = !notice; el.hidden = !!notice; el.textContent = onAirText(); }
    else { el.textContent = notice || onAirText(); }
  }
  renderOnAir(); setInterval(renderOnAir, 60000);

  /* ------------------------------------------------------------------ player */
  var audio = null, hls = null, attached = false, wantPlaying = false, retries = 0, retryTimer = null, state = "idle";
  function setNotice(text) { notice = text || ""; renderOnAir(); }
  function setState(s) {                             // idle | connecting | playing | error
    state = s;
    var btn = byId("PlayerPlay"), icon = byId("PlayerIcon"), live = s === "playing" || s === "connecting";
    if (btn) {
      btn.setAttribute("aria-pressed", live ? "true" : "false");
      btn.setAttribute("aria-label", s === "playing" ? "Stop" : s === "connecting" ? "Connecting, press to cancel" : s === "error" ? "Try playing " + STATION + " again" : "Play " + STATION);
      btn.classList.toggle("is-connecting", s === "connecting");
      btn.classList.toggle("is-error", s === "error");
    }
    if (icon) { icon.setAttribute("d", live ? "M6 6h12v12H6z" : "M8 5v14l11-7z"); }
    Array.prototype.forEach.call(document.querySelectorAll("[data-listen-label]"), function (a) {
      a.textContent = s === "playing" ? "Stop" : s === "connecting" ? "Connecting…" : a.getAttribute("data-listen-label");
    });
    if (s !== "error") { setNotice(""); }
    if ("mediaSession" in navigator) { try { navigator.mediaSession.playbackState = s === "playing" ? "playing" : "none"; } catch (e) { /* older browsers */ } }
  }
  function useNativeHls(a) {
    if (!a.canPlayType("application/vnd.apple.mpegurl")) { return false; }
    var ua = navigator.userAgent;
    var appleWebKit = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ||
                      (/Safari\//.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|EdgA?\/|OPR|Android/.test(ua));
    return appleWebKit || !(window.MediaSource || window.ManagedMediaSource);
  }
  function newAudio() {
    var a = new Audio(), v = document.querySelector("#PlayerVolume input");
    a.preload = "none";
    if (v) { a.volume = parseFloat(v.value); }
    a.addEventListener("playing", function () { if (a === audio) { retries = 0; setState("playing"); } });
    a.addEventListener("waiting", function () { if (a === audio && wantPlaying && state === "playing") { setState("connecting"); } });
    a.addEventListener("error", function () { if (a === audio && attached) { recover(); } });
    a.addEventListener("ended", function () { if (a === audio && wantPlaying) { recover(); } });
    a.addEventListener("pause", function () { if (a === audio && wantPlaying && state === "playing") { stop(); } });   // paused by the OS or headphones
    return a;
  }
  function teardown() {
    var a = audio; audio = null; attached = false;
    if (hls) { try { hls.destroy(); } catch (e) { /* already gone */ } hls = null; }
    if (a) { try { a.pause(); a.removeAttribute("src"); a.load(); } catch (e) { /* already gone */ } }
  }
  function attach(done, fail) {
    var a = audio = newAudio();
    function native() { a.src = STREAM_URL; attached = true; done(); }
    if (useNativeHls(a)) { return native(); }
    function viaHls() {
      if (a !== audio) { return; }                  // stopped while hls.js was loading
      if (!(window.Hls && window.Hls.isSupported())) { return a.canPlayType("application/vnd.apple.mpegurl") ? native() : fail(); }
      var h = hls = new window.Hls({ enableWorker: true, lowLatencyMode: false, backBufferLength: 30 });
      h.on(window.Hls.Events.ERROR, function (_, data) {
        if (h !== hls || !data || !data.fatal) { return; }
        if (data.type === window.Hls.ErrorTypes.NETWORK_ERROR && retries < 3) { retries++; h.startLoad(); return; }
        if (data.type === window.Hls.ErrorTypes.MEDIA_ERROR && retries < 3) { retries++; h.recoverMediaError(); return; }
        recover();
      });
      h.loadSource(STREAM_URL); h.attachMedia(a); attached = true; done();
    }
    if (window.Hls) { return viaHls(); }
    var s = document.createElement("script"); s.src = HLS_SRC; s.async = true;
    s.onload = viaHls;
    s.onerror = function () { if (a === audio) { if (a.canPlayType("application/vnd.apple.mpegurl")) { native(); } else { fail(); } } };
    document.head.appendChild(s);
  }
  function start() {
    clearTimeout(retryTimer);
    setState("connecting");
    attach(function () {
      var a = audio; if (!a) { return; }
      var p = a.play();
      if (p && p["catch"]) {
        p["catch"](function (e) {
          if (a !== audio) { return; }               // superseded by a stop or a retry
          if (e && e.name === "NotAllowedError") { wantPlaying = false; teardown(); setState("idle"); return; }   // the browser wants another tap
          recover();
        });
      }
    }, recover);
  }
  function recover() {
    if (!wantPlaying) { return; }
    teardown();
    if (retries < 3) {
      retries++; setState("connecting");
      retryTimer = setTimeout(function () { if (wantPlaying) { start(); } }, 1200 * retries);
    } else {
      wantPlaying = false; setState("error");
      setNotice("The stream didn't start. Press play to try again.");
    }
  }
  function play() { if (!STREAM_URL || wantPlaying) { return; } wantPlaying = true; retries = 0; start(); }
  function stop() { clearTimeout(retryTimer); wantPlaying = false; teardown(); setState("idle"); }
  function togglePlay() { if (wantPlaying) { stop(); } else { play(); } }
  function paintPlayer() {                            // (re)apply state to player markup, e.g. after the theme editor re-renders it
    var vol = byId("PlayerVolume"), btn = byId("PlayerPlay");
    if (vol && STREAM_URL) { vol.classList.add("on"); var v = vol.querySelector("input"); if (v && audio) { v.value = audio.volume; } }
    if (btn) { btn.disabled = !STREAM_URL; }
    setState(state); renderOnAir();
  }
  paintPlayer();
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    if (t.closest("#PlayerPlay")) { togglePlay(); return; }
    var listen = t.closest('a[href="#listen"]');
    if (listen) { e.preventDefault(); togglePlay(); return; }
    var tg = t.closest(".nav-toggle"), nav = byId("site-nav");
    if (tg && nav) { var open = nav.classList.toggle("open"); tg.setAttribute("aria-expanded", open ? "true" : "false"); }
  });
  document.addEventListener("input", function (e) {
    if (e.target && e.target.closest && e.target.closest("#PlayerVolume") && audio) { audio.volume = parseFloat(e.target.value); }
  });
  if ("mediaSession" in navigator) {
    try {
      navigator.mediaSession.setActionHandler("play", play);
      navigator.mediaSession.setActionHandler("pause", stop);
      navigator.mediaSession.setActionHandler("stop", stop);
    } catch (e) { /* some actions unsupported */ }
  }
  function absolute(u) { var a = document.createElement("a"); a.href = u; return a.href; }

  /* ------------------------------------------------------------------ now playing: iHeart live metadata for the station's stream */
  var lastKey = null, lastCurrent = null, lastHistory = [], historyLoaded = false;
  function trackKey(t) { return t ? (t.trackId || "") + "|" + t.title + "|" + (t.artist || "") : ""; }
  function artUrl(path, size) {                      // small JPEG from iHeart's image service instead of the multi-megabyte original
    try { return "https://i.iheart.com/v3/url/" + btoa(path).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "") + "?ops=fit(" + size + "," + size + ")"; }
    catch (e) { return path.replace(/^http:/, "https:"); }
  }
  function setArt(img, path, size) {                 // resized artwork -> original file -> default artwork
    var full = path ? path.replace(/^http:/, "https:") : "";
    img.onerror = null;
    if (!full) { img.src = DEFAULT_ART; return; }
    img.onerror = function () { img.onerror = function () { img.onerror = null; img.src = DEFAULT_ART; }; img.src = full; };
    img.src = artUrl(path, size);
  }
  function playedAt(t) {
    var ms = Number(t.startTime) || 0;
    if (ms && ms < 1e12) { ms *= 1000; }             // history gives seconds, the current track milliseconds
    if (!ms) { return ""; }
    var d = new Date(ms);
    return fmt(d.getHours() + d.getMinutes() / 60);
  }
  function mediaSession(t) {
    if (!("mediaSession" in navigator) || typeof window.MediaMetadata !== "function") { return; }
    try {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: t ? t.title : STATION, artist: t ? (t.artist || STATION) : onAirText(), album: (STATION + " " + BADGE).trim(),
        artwork: [{ src: t && t.imagePath ? artUrl(t.imagePath, 512) : absolute(DEFAULT_ART), sizes: "512x512" }]
      });
    } catch (e) { /* metadata unsupported */ }
  }
  function renderPlayer(t) {
    var title = byId("NowTitle"), badge = byId("NowBadge"), artist = byId("NowArtist"), art = byId("NowArt");
    if (!title) { return; }
    var key = trackKey(t);
    if (key === lastKey) { return; }
    lastKey = key;
    var img = art && art.querySelector("img");
    title.textContent = t ? t.title : STATION;
    if (badge) { badge.hidden = !!t || !BADGE; }
    if (artist) { artist.textContent = t ? (t.artist || "") : ""; artist.hidden = !(t && t.artist); }
    if (img) { setArt(img, t ? t.imagePath : "", 80); }
    mediaSession(t);
  }
  function renderRow() {
    var section = byId("NowPlayingSection"), row = byId("RowTracks");
    if (!row || !section) { return; }
    var limit = parseInt(row.getAttribute("data-count"), 10) || HISTORY, items = [];
    if (lastCurrent) { items.push({ t: lastCurrent, live: true }); }
    lastHistory.forEach(function (h) { if (h && h.title && trackKey(h) !== trackKey(lastCurrent)) { items.push({ t: h, live: false }); } });
    items = items.slice(0, limit + 1);
    if (!items.length) { section.hidden = true; row.innerHTML = ""; return; }
    row.innerHTML = items.map(function (it) {
      var when = playedAt(it.t);
      return '<div class="card track-card' + (it.live ? " is-live" : "") + '"><div class="thumb"><img alt="" decoding="async" width="320" height="320">' +
        (it.live ? '<span class="live-tag">On air</span>' : "") + '</div><div class="body"><h3>' + esc(it.t.title) + "</h3>" +
        '<div class="meta">' + esc(it.t.artist || STATION) + "</div>" +
        (it.live ? '<span class="when">Now playing</span>' : (when ? '<span class="when">Played ' + esc(when) + "</span>" : "")) + "</div></div>";
    }).join("");
    Array.prototype.forEach.call(row.querySelectorAll(".track-card img"), function (img, k) { setArt(img, items[k].t.imagePath, 320); });
    section.hidden = false;
  }
  function getJSON(url, ok, fail) {
    window.fetch(url, { cache: "no-store" })
      .then(function (r) { if (!r.ok) { throw new Error(String(r.status)); } return r.json(); })
      .then(ok)["catch"](fail);
  }
  function pollNow(force) {                          // repeat polls pause while the tab is hidden; visibilitychange catches up
    if (!META_URL || (document.hidden && !force)) { return; }
    getJSON(META_URL, function (d) {
      var t = (d && d.title) ? d : null, changed = trackKey(t) !== trackKey(lastCurrent);
      lastCurrent = t; renderPlayer(t);
      if (changed) { renderRow(); }
    }, function () { lastCurrent = null; renderPlayer(null); renderRow(); });
  }
  function pollHistory(force) {
    if (!HISTORY_URL || !byId("RowTracks") || (document.hidden && !force)) { return; }
    getJSON(HISTORY_URL, function (d) { historyLoaded = true; lastHistory = (d && d.data) ? d.data : []; renderRow(); },
            function () { historyLoaded = true; lastHistory = []; renderRow(); });
  }
  if (window.fetch && window.Promise) {
    renderPlayer(null);
    pollNow(true); pollHistory(true);
    setInterval(function () { pollNow(false); }, 30000); setInterval(function () { pollHistory(false); }, 60000);
    document.addEventListener("visibilitychange", function () { if (!document.hidden) { pollNow(); pollHistory(); } });
  }

  /* ------------------------------------------------------------------ page components (re-run after in-place navigation or an editor re-render) */
  function all(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function renderGrille(root) {                      // home: three-day programme grid
    all(root, "#Grille, [data-hr-grille]").forEach(function (grille) {
      var st = nowOnAir(), labels = ["Today", "Tomorrow", "Day after"], out = "";
      for (var k = 0; k < 3; k++) {
        var d = (st.day + k) % 7, shows = showsFor(DAYS[d]), rows = "", max = 6;
        shows.slice(0, max).forEach(function (sh) {
          var live = k === 0 && sh.start <= st.hour && st.hour < sh.end, t = splitTitle(sh.title);
          rows += "<li" + (live ? ' class="now"' : "") + '><img src="' + THUMB + '" alt="" width="40" height="40"><span class="title">' + esc(t.name) + (t.with ? '<span class="with">with ' + esc(t.with) + "</span>" : "") + "</span><time>" + CLOCK_ICON + fmt(sh.start) + "</time></li>";
        });
        if (!shows.length) { rows = '<li><span class="title muted">No programmes listed</span></li>'; }
        out += '<div class="card day-card"><span class="eyebrow">' + labels[k] + "</span><h2>" + DAYS[d] + '</h2><ul class="show-rows">' + rows + "</ul>" +
               (shows.length > max ? '<a class="more" href="' + GUIDE_URL + '">+ ' + (shows.length - max) + " more</a>" : '<a class="more" href="' + GUIDE_URL + '">Full schedule</a>') + "</div>";
      }
      grille.innerHTML = out;
    });
  }
  function renderToday(root) {                       // what's on today list (if a page has one)
    all(root, "#WhatsOnToday").forEach(function (box) {
      var s = nowOnAir(), out = "";
      s.today.forEach(function (sh) {
        var live = sh.start <= s.hour && s.hour < sh.end;
        out += "<li" + (live ? ' class="now"' : "") + '><img src="' + THUMB + '" alt="" width="40" height="40"><span class="title">' + esc(sh.title) + "</span><time>" + CLOCK_ICON + fmt(sh.start) + "</time></li>";
      });
      box.innerHTML = out || '<li><span class="title muted">No programmes listed for ' + s.dayName + ".</span></li>";
    });
  }
  function dayTabs(root) {                           // day tabs on the old schedule page
    all(root, ".day-tabs").forEach(function (tabs) {
      if (tabs.getAttribute("data-hr-ready")) { return; }
      tabs.setAttribute("data-hr-ready", "1");
      var sections = all(document, ".day-section");
      var pick = function (day) {
        all(tabs, "button").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-day") === day ? "true" : "false"); });
        sections.forEach(function (sec) { sec.hidden = !(day === "All" || sec.getAttribute("data-day") === day); });
      };
      tabs.addEventListener("click", function (e) { var b = e.target.closest("button[data-day]"); if (b) { pick(b.getAttribute("data-day")); } });
      var todayName = DAYS[new Date().getDay()];
      pick(tabs.querySelector('button[data-day="' + todayName + '"]') ? todayName : "All");
      var st = nowOnAir();
      if (st.current) { all(document, '.day-section[data-day="' + st.dayName + '"] .show-card').forEach(function (c) { if (c.getAttribute("data-title") === st.current.title) { c.classList.add("is-now"); } }); }
    });
  }
  function renderGuides(root) {                      // programme guide: weekly table (wide screens) + stacked day list (phones)
    all(root, "[data-hr-guide]").forEach(function (el) {
      var cols = ORDER.filter(function (d) { return showsFor(d).length; });
      if (!cols.length) { el.innerHTML = '<p class="muted">No programmes are listed yet.</p>'; return; }
      var slots = {}, lo = 24, hi = 0, used = [];
      cols.forEach(function (d) {
        slots[d] = showsFor(d);
        slots[d].forEach(function (s) { lo = Math.min(lo, s.start); hi = Math.max(hi, s.end); if (s.cat && used.indexOf(s.cat) < 0) { used.push(s.cat); } });
      });
      lo = Math.floor(lo); hi = Math.ceil(hi); used.sort();
      var n = cols.length + 1, label = function (s) { return s.link ? '<a href="' + esc(s.link) + '">' + esc(s.title) + "</a>" : esc(s.title); };
      var h = '<div class="programguide-wrap"><table class="programguide table-bordered"><colgroup><col class="time-col">' + new Array(cols.length + 1).join("<col>") + "</colgroup>";
      h += '<tr><th colspan="' + n + '" class="legend text-center"><span class="guide-title">' + esc(el.getAttribute("data-title") || GUIDE_TITLE) + "</span></th></tr>";
      if (used.length) { h += '<tr><td colspan="' + n + '"><ul class="legend-list" aria-label="Category colours">' + used.map(function (c) { return '<li><span class="cat-swatch" style="background-color:' + esc(catColour(c)) + '"></span>' + esc(c) + "</li>"; }).join("") + "</ul></td></tr>"; }
      h += '<tr><th scope="col" class="legend">Time</th>' + cols.map(function (d) { return '<th scope="col" class="legend">' + d + "</th>"; }).join("") + "</tr>";
      var covered = {}; cols.forEach(function (d) { covered[d] = 0; });
      for (var hr = lo; hr < hi; hr++) {
        var cells = '<th scope="row" class="time">' + fmtHour(hr) + "</th>";
        cols.forEach(function (d) {
          if (covered[d] > hr) { return; }
          var show = null;
          slots[d].forEach(function (s) { if (!show && Math.floor(s.start) === hr) { show = s; } });
          if (show) {
            var span = Math.max(1, Math.round(show.end - show.start)); covered[d] = show.start + span;
            cells += '<td rowspan="' + span + '" style="background-color:' + esc(catColour(show.cat)) + ';"><strong>' + label(show) + "</strong><br>" + fmtHour(show.start) + " - " + fmtHour(show.end) + "</td>";
          } else { cells += '<td class="empty">&nbsp;</td>'; }
        });
        h += "<tr>" + cells + "</tr>";
      }
      h += '</table></div><div class="guide-mobile">';
      cols.forEach(function (d) {
        h += '<section class="gm-day"><h3>' + d + '</h3><ul class="gm-list">' + slots[d].map(function (s) {
          return '<li><span class="gm-time">' + fmtHour(s.start) + " &ndash; " + fmtHour(s.end) + '</span><span class="gm-show">' +
                 (s.cat ? '<span class="cat-swatch" style="background-color:' + esc(catColour(s.cat)) + '"></span> ' : "") + label(s) + "</span></li>";
        }).join("") + "</ul></section>";
      });
      el.innerHTML = h + "</div>";
    });
  }
  function renderShowSchedules(root) {               // show pages: airtime chips + "when to listen" week list for a keyword
    all(root, "[data-hr-show-times]").forEach(function (el) {
      var kw = (el.getAttribute("data-hr-show-times") || "").toLowerCase(), slots = {}, order = [];
      if (!kw) { return; }
      ORDER.forEach(function (d) { showsFor(d).forEach(function (s) { if (s.title.toLowerCase().indexOf(kw) >= 0) { if (!slots[s.time]) { slots[s.time] = []; order.push(s.time); } slots[s.time].push(ABBR[d]); } }); });
      el.innerHTML = order.map(function (t) { var ds = slots[t], lbl = ds.length === 1 ? ds[0] : ds.slice(0, -1).join(", ") + " & " + ds[ds.length - 1]; return "<li>" + esc(lbl) + " &middot; " + esc(t) + "</li>"; }).join("");
      el.hidden = !order.length;
    });
    all(root, "[data-hr-show-week]").forEach(function (el) {
      var kw = (el.getAttribute("data-hr-show-week") || "").toLowerCase(), rows = "";
      if (!kw) { return; }
      ORDER.forEach(function (d) {
        showsFor(d).forEach(function (s) {
          if (s.title.toLowerCase().indexOf(kw) < 0) { return; }
          var t = splitTitle(s.title);
          rows += '<li data-day="' + d + '" data-title="' + esc(s.title) + '"><span class="day">' + ABBR[d] + '</span><span class="title">' + esc(t.name) + (t.with ? '<span class="with">with ' + esc(t.with) + "</span>" : "") + "</span><time>" + esc(s.time) + "</time></li>";
        });
      });
      el.innerHTML = rows || '<li><span class="title muted">No airtimes listed yet.</span></li>';
    });
  }
  function markShowWeek(root) {                      // single-show pages: mark the slot that is on air
    var sw = nowOnAir();
    all(root, ".show-week").forEach(function (week) {
      all(week, "li.now").forEach(function (li) { li.classList.remove("now"); });
      if (sw.current) { all(week, 'li[data-day="' + sw.dayName + '"]').forEach(function (li) { if (li.getAttribute("data-title") === sw.current.title) { li.classList.add("now"); } }); }
    });
  }
  function rowArrows(root) {                         // horizontal rows with arrow buttons
    all(root, "[data-scroll]").forEach(function (btn) {
      if (btn.getAttribute("data-hr-ready")) { return; }
      btn.setAttribute("data-hr-ready", "1");
      btn.addEventListener("click", function () {
        var row = byId(btn.getAttribute("data-scroll"));
        if (row) { row.scrollBy({ left: (btn.getAttribute("data-dir") === "prev" ? -1 : 1) * Math.max(240, row.clientWidth * 0.8), behavior: "smooth" }); }
      });
    });
  }
  function heroes(root) {                            // photo slideshow: deferred images, dots, pause control
    all(root, ".hero").forEach(function (hero) {
      if (hero._hrGo) { return; }
      var slides = all(hero, ".slide"), dots = hero.querySelector(".hero-dots"), pauseBtn = hero.querySelector(".hero-pause"), i = 0, timer = null, paused = false;
      if (!slides.length) { return; }
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var every = Math.max(3, parseInt(hero.getAttribute("data-interval"), 10) || 6) * 1000;
      var load = function (k) {                      // slides after the first carry data-src (and data-srcset) until needed
        var img = slides[(k + slides.length) % slides.length].querySelector("img[data-src]");
        if (!img) { return; }
        if (img.getAttribute("data-srcset")) { img.sizes = img.getAttribute("data-sizes") || "100vw"; img.srcset = img.getAttribute("data-srcset"); img.removeAttribute("data-srcset"); }
        img.src = img.getAttribute("data-src"); img.removeAttribute("data-src");
      };
      var count = document.createElement("span"); count.className = "hero-count"; count.setAttribute("aria-hidden", "true"); hero.appendChild(count);
      var go = function (n) {
        i = (n + slides.length) % slides.length;
        load(i); load(i + 1);
        count.textContent = (i + 1) + " / " + slides.length;
        slides.forEach(function (sl, k) { sl.classList.toggle("is-active", k === i); sl.setAttribute("aria-hidden", k === i ? "false" : "true"); });
        if (dots) { all(dots, "button").forEach(function (b, k) { b.setAttribute("aria-current", k === i ? "true" : "false"); }); }
      };
      var stopTimer = function () { if (timer) { clearInterval(timer); timer = null; } };
      var startTimer = function () { if (!reduce && !paused && slides.length > 1) { stopTimer(); timer = setInterval(function () { go(i + 1); }, every); } };
      if (dots) {
        dots.innerHTML = "";
        slides.forEach(function (_, k) {
          var b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-label", "Show photo " + (k + 1));
          b.addEventListener("click", function () { go(k); startTimer(); }); dots.appendChild(b);
        });
      }
      var paint = function () {
        if (!pauseBtn) { return; }
        pauseBtn.setAttribute("aria-pressed", paused ? "true" : "false");
        pauseBtn.setAttribute("aria-label", paused ? "Play slideshow" : "Pause slideshow");
        var ic = pauseBtn.querySelector("path"); if (ic) { ic.setAttribute("d", paused ? "M8 5v14l11-7z" : "M6 5h4v14H6zM14 5h4v14h-4z"); }
      };
      if (pauseBtn) {
        if (reduce || DESIGN_MODE) { paused = true; }  // no auto-advance while editing, so a slide stays put
        pauseBtn.addEventListener("click", function () { paused = !paused; if (paused) { stopTimer(); } else { reduce = false; startTimer(); } paint(); });
        paint();
      }
      var prev = hero.querySelector(".hero-nav.prev"), next = hero.querySelector(".hero-nav.next");
      if (prev) { prev.addEventListener("click", function () { go(i - 1); startTimer(); }); }
      if (next) { next.addEventListener("click", function () { go(i + 1); startTimer(); }); }
      hero.addEventListener("mouseenter", stopTimer); hero.addEventListener("mouseleave", startTimer);
      hero.addEventListener("focusin", stopTimer); hero.addEventListener("focusout", startTimer);
      hero.addEventListener("keydown", function (e) { if (e.key === "ArrowLeft") { go(i - 1); } if (e.key === "ArrowRight") { go(i + 1); } });
      hero._hrGo = function (k, hold) { go(k); if (hold) { paused = true; stopTimer(); paint(); } };
      hero._hrStop = stopTimer;
      go(0); startTimer();
    });
  }
  function stopHeroes(root) { all(root, ".hero").forEach(function (h) { if (h._hrStop) { h._hrStop(); } }); }
  function markListenLinks(root) {
    all(root, 'a[href="#listen"]').forEach(function (a) { if (!a.getAttribute("data-listen-label")) { a.setAttribute("data-listen-label", a.textContent.trim()); } });
    setState(state);
  }
  function renderSchedule(root) { renderGrille(root); renderToday(root); renderGuides(root); renderShowSchedules(root); markShowWeek(root); }
  function initPage(root) {
    renderSchedule(root); dayTabs(root); rowArrows(root); heroes(root); markListenLinks(root);
    renderRow(); if (!historyLoaded || !lastHistory.length) { pollHistory(true); }
  }
  initPage(document);

  /* ------------------------------------------------------------------ theme editor: re-run components when Shopify re-renders a section */
  if (DESIGN_MODE) {
    document.addEventListener("shopify:section:load", function (e) {
      var oldNow = NOW_ID;
      readSettings(); loadSchedule(); lastKey = null; tick();
      initPage(e.target); renderSchedule(document); paintPlayer(); renderPlayer(lastCurrent);
      if (NOW_ID !== oldNow) { lastCurrent = null; lastHistory = []; pollNow(true); pollHistory(true); }
    });
    document.addEventListener("shopify:section:unload", function (e) { stopHeroes(e.target); });
    document.addEventListener("shopify:block:select", function (e) {
      var slide = e.target && e.target.closest && e.target.closest(".slide"), hero = slide && slide.closest(".hero");
      if (hero && hero._hrGo) { hero._hrGo(all(hero, ".slide").indexOf(slide), true); }
    });
  }

  /* ------------------------------------------------------------------ keep the stream playing between pages */
  var softReady = !!(window.fetch && window.history && window.history.pushState && window.DOMParser && window.URL);
  function softNavigate(href, push) {
    var main = byId("main");
    if (!main) { location.href = href; return; }
    document.documentElement.classList.add("is-navigating");
    window.fetch(href, { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok && r.status !== 404) { throw new Error(String(r.status)); }
        return r.text().then(function (text) { return { text: text, url: r.url || href }; });
      })
      .then(function (res) {
        var doc = new DOMParser().parseFromString(res.text, "text/html"), next = doc.getElementById("main");
        if (!next) { throw new Error("no main"); }
        stopHeroes(main);
        main.innerHTML = next.innerHTML;
        document.title = doc.title;
        var nav = byId("site-nav"), nextNav = doc.getElementById("site-nav"), tg = document.querySelector(".nav-toggle");
        if (nav && nextNav) { nav.innerHTML = nextNav.innerHTML; nav.classList.remove("open"); }
        if (tg) { tg.setAttribute("aria-expanded", "false"); }
        var desc = document.querySelector('meta[name="description"]'), nextDesc = doc.querySelector('meta[name="description"]');
        if (desc && nextDesc) { desc.setAttribute("content", nextDesc.getAttribute("content")); }
        if (push) {
          if (!history.state || !history.state.hrSoft) { history.replaceState({ hrSoft: true }, "", location.href); }
          history.pushState({ hrSoft: true }, "", res.url);
        }
        var hash = new URL(res.url, location.href).hash, target = hash && byId(decodeURIComponent(hash.slice(1)));
        if (target) { target.scrollIntoView(); } else { window.scrollTo(0, 0); }
        initPage(main);
        main.setAttribute("tabindex", "-1");
        try { main.focus({ preventScroll: true }); } catch (e) { main.focus(); }
      })["catch"](function () { location.href = href; })
      .then(function () { document.documentElement.classList.remove("is-navigating"); });
  }
  document.addEventListener("click", function (e) {
    if (!softReady || !wantPlaying || DESIGN_MODE) { return; }      // only needed while the stream is on
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var a = e.target && e.target.closest && e.target.closest("a[href]");
    if (!a || (a.target && a.target !== "_self") || a.hasAttribute("download")) { return; }
    var href = a.getAttribute("href");
    if (!href || href.charAt(0) === "#" || /^(mailto|tel|sms|javascript):/i.test(href)) { return; }
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) { return; }
    if (url.pathname === location.pathname && url.search === location.search) { return; }
    if (/^\/(admin|cart|checkout|checkouts|account|password|apps|services|tools|challenge)(\/|$)/.test(url.pathname)) { return; }
    if (/\.(pdf|zip|mp3|m3u8?|xml|json|txt|jpe?g|png|gif|webp|svg)$/i.test(url.pathname)) { return; }
    e.preventDefault();
    softNavigate(url.href, true);
  });
  window.addEventListener("popstate", function (e) { if (softReady && e.state && e.state.hrSoft) { softNavigate(location.href, false); } });
})();
